import * as React from 'react';
import styled from '@emotion/styled';
import SummariesTable from '../tables/SummariesTable';
import VMIcon from '../icons/VMIcon';
import OSIcon from '../icons/OSIcon';
import MemoryIcon from '../icons/MemoryIcon';
import CapacityIcon from '../icons/CapacityIcon';
import CPUIcon from '../icons/CPUIcon';
import { tableViewModel } from '../models/views/tableViewModel';

const SummaryView = styled.div`
  background: #fff;
  box-shadow: 20px 0 0 0 #fff;
  display: block;
  font-size: 1.2rem;
`;
const SummarySection = styled.section`
  width: 33%;
  display: inline-grid;
`;
const FallbackText = styled.p`
  text-align: center;
  max-width: 100%;
`;

interface Props {
  data: {
    averageVMData: tableViewModel[];
    guestOSData: tableViewModel[];
    memoryData: tableViewModel[];
    vcpuData: tableViewModel[];
    capacityData: tableViewModel[];
  };
  noData: boolean;
}

class VirtualSummaryBody extends React.Component<Props> {
  render() {
    return this.props.noData ? (
      <FallbackText>No data to display</FallbackText>
    ) : (
      <SummaryView>
        <SummarySection>
          <SummariesTable
            title="Average Virtual Machine"
            titleIcon={<VMIcon />}
            data={this.props.data.averageVMData}
          />
        </SummarySection>

        <SummarySection>
          <SummariesTable
            title="Guest OS Count"
            titleIcon={<OSIcon />}
            data={this.props.data.guestOSData}
          />
          <SummariesTable
            title="Memory"
            titleIcon={<MemoryIcon />}
            data={this.props.data.memoryData}
          />
        </SummarySection>

        <SummarySection>
          <SummariesTable title="vCPU" titleIcon={<CPUIcon />} data={this.props.data.vcpuData} />
          <SummariesTable
            title="Capacity"
            titleIcon={<CapacityIcon />}
            data={this.props.data.capacityData}
          />
        </SummarySection>
      </SummaryView>
    );
  }
}
export default VirtualSummaryBody;
